

export enum KalturaUserJoinPolicyType {
    autoJoin=1,
	notAllowed=3,
	requestToJoin=2
}